<app-parameters-header [activeSection]="currentSection"></app-parameters-header>
<div class="parameters-container container">
  <div class="row parameters-body">
    <div class="d-none d-lg-block col-lg-3">
      <app-parameters-scrollspy [activeSection]="currentSection"></app-parameters-scrollspy>
    </div>
    <div class="col-12 col-lg-9" appScrollSpyMenu [spiedTags]="['DIV']" (sectionChange)="onSectionChange($event)">
      <div id="parameters-user" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-user></app-parameters-user>
      </div>
      <div id="parameters-accessibility" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-accessibility [settings]='settings' [company]='false'></app-parameters-accessibility>
      </div>
      <div *ngIf="privateCompany" id="parameters-company" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-company [settings]='settings' [company]='false'></app-parameters-company>
      </div>
      <div id="parameters-reports" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-reports [company]='false' [settings]="settings" [report]="settings?.report" [company]='false'>
        </app-parameters-reports>
      </div>
      <div id="parameters-style" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-style [company]='false' [settings]="settings"></app-parameters-style>
      </div>
      <!-- <div id="parameters-cost" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-cost [company]='false' [vehicle]="settings?.vehicle" [cost]="settings?.cost"></app-parameters-cost>
      </div> -->
      <div id="parameters-notifications" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <!-- //TODO :  edit : <app-parameters-notifications [company]='false' [settings]="settings?.notification" ></app-parameters-notifications> -->
      </div>
      <div id="parameters-language" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-language [company]='false' [language]="settings?.language"></app-parameters-language>
      </div> 
      <div id="parameters-session" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <div class="container">
          <div class="row head">
            <div class="col-12">
              <span i18n="params|@@session" class="title">Session</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 report-form">
              <span class="column-title" i18n="params|@@profile">Profil</span>
              <div class="container">
                <div class="row generalrows">
                  <div class="col-5 center">
                    <span i18n="params" class="span-txt" i18n="params|@@connectedAs">Connecté en tant que : {{username}}</span>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-lg danger" i18n="params|@@logout" (click)="logout()">Se déconnecter</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/params/params.component.html